module.exports = __webpack_public_path__ + "static/showreel_2024-3102531b330bf4298b61218c2f8b8dde.jpg";